
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/quicksell-for-toys",
      function () {
        return require("private-next-pages/quicksell-for-toys/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/quicksell-for-toys"])
      });
    }
  